import {Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {SchoolProgramService} from "../../../../shared/services/school-program.service";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";
import {faPen, faTrash, faUser} from "@fortawesome/free-solid-svg-icons";
import {FormControl, FormGroup} from "@angular/forms";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from 'src/shared/services/translate.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { AuthService } from 'src/shared/services/auth.service';

@Component({
    selector: 'school-program-table',
    styleUrls: ['school-program-table.component.scss'],
    templateUrl: 'school-program-table.component.html',
})
export class SchoolProgramTableComponent implements OnInit, OnChanges{
    @ViewChild('updateSchoolProgram', {static: true}) public modalUpdateSchoolProgram: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private schoolProgramService: SchoolProgramService,
        private toastr: ToastrService,
        private translate: TranslateService,
        private rpSer: ResponseService,
        public auth: AuthService
    ){

    }
    category: any;
    data: any;
    editingRow: any = null;
    editingColumn: any = null;
    loading = false;
    @Input()
    school_location_id = null;
    @Input()
    academic_year: any = null;
    @Input()
    triggerChanges = false;
    @Input()
    search: any = null;
    faEdit = faPen;
    faDelete = faTrash;
    heading = "School Program Table"

    currentData: FormGroup;
    disableFormSubmit: boolean = true;
    currentIndex: number;
    async ngOnInit() {
        this.auth.loadPermissions(true);
        this.translate.load('extracurricular', 'activity');
        await this.setPage();
        this.initForm();
        this.trackFormChanges();
    }
    trackFormChanges() {
        this.currentData.valueChanges.subscribe(() => {
            this.disableFormSubmit =
                !this.currentData.get('school_program_id')?.value ||
                !this.currentData.get('school_program_name')?.value ||
                !this.currentData.get('school_program_description')?.value;
        });
    }
    initForm() {
        this.currentData = new FormGroup({
            'school_program_id': new FormControl(null),
            'school_program_name': new FormControl(null),
            'school_program_description': new FormControl(null),
        })
    }

    async setPage($event: any = null) {
        const data = {
            school_location_id: this.school_location_id,
            academic_year: this.academic_year,
            search: this.search,
        }
        this.loading = true;
        this.schoolProgramService.getSchoolProgram(data).subscribe((
            response: any) => {
            if(response['status']) {
                this.data = response['data'];
                this.loading = false;
            } else {
                this.loading = false;
            }
        },(error) => {
            this.loading = false;
        })
    }

    isEditing(row: any, column: any): boolean {
        return this.editingRow === row && this.editingColumn == column;
    }

    startEdit(row: any, column: any): void {
        this.editingRow = row;
        this.editingColumn = column;
    }


    onEditComplete(row: any): void {
        this.editingRow = null;
        this.editingColumn = null;

        this.updateData(row);

    }

    async ngOnChanges() {
        await this.setPage();
    }

    updateData(data: any){
        this.schoolProgramService.updateSchoolProgramCategory(data).subscribe(
            (response: any) => {
                if (response['status']) {
                    this.toastr.success('[' + this.heading + '] ' + response['message'], 'Success');
                } else {
                    this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                }
            },
            (error: any) => {
                this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
            }
        );
    }

    delete(data: any) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this category?',
            iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/delete-success-v2.svg" alt="tes">',
            customClass: {
                icon: 'no-border'
            },
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.schoolProgramService.deleteSchoolProgramCategory(data.school_program_category_id).subscribe(
                    async (response: any) => {
                        if (response['status']) {
                            this.rpSer.showDeleteSuccess('The category has been deleted.');
                            this.setPage();
                        } else {
                            this.rpSer.showDeleteFailed(response.message);
                        }
                    },
                    (error: any) => {
                        this.rpSer.showDeleteFailed();
                    }
                );
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        });
    }

    onOpenModelEditModal (index: number) {
        const current = this.data[index];
        if (!current) {
          return;
        }
        this.currentData.controls['school_program_id'].setValue(current ? current.school_program_id : null);
        this.currentData.controls['school_program_name'].setValue(current ? current.school_program_name : null);
        this.currentData.controls['school_program_description'].setValue(current ? current.school_program_description : null);


        this.modalService.open(this.modalUpdateSchoolProgram, {
            ariaLabelledBy: 'modal-basic-title',
            keyboard: false,
            size: 'lg'
        }).result.then((result: any) => {

        }, (reason: any) => {

        });


    }
    editSchoolProgram() {
        this.schoolProgramService.updateSchoolProgram(this.currentData.value).subscribe(
           async (response: any) => {
                if (response['status']) {
                    this.rpSer.showEditSuccess('The school program has been updated successfully.');
                   await this.setPage();
                   this.initForm();
                    this.modalService.dismissAll();
                } else {
                    this.rpSer.showEditFailed('Failed to update the school program. Please try again.');
                }
            },
            (error: any) => {
                this.rpSer.showEditFailed();
            }
        );
    }

    deleteSchoolProgram(index: number){
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this school program?',
            iconHtml: '<img src="https://files.sokrates.co.id/design-systems/illustration/alert/delete-success-v2.svg" alt="tes">',
            customClass: {
                icon: 'no-border'
            },
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.schoolProgramService.deleteSchoolProgram(this.data[index].school_program_id).subscribe(
                    async (response: any) => {
                        if (response['status']) {
                            this.rpSer.showDeleteSuccess('The school program has been deleted.');
                            this.setPage();
                        } else {
                            await Swal.fire('Error!', response.message, 'error');
                        }
                    },
                    (error: any) => {
                        this.rpSer.showDeleteFailed();
                    }
                );
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        });
    }
}

